module.exports = __webpack_public_path__ + "images/canonical-card/attachment-icon.1cfee90d567b657e6d58.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/attachment-icon.svg
// module id = Hi6H
// module chunks = 2